import React, { useState } from 'react'
import { FormGroup, Label, Button } from 'reactstrap'
import Input from './Input'
import { get, post, put } from '../modules/fetch'
import { Redirect } from 'react-router-dom'
import model_array from '../modules/model_array'
import { If } from '../modules/helpers'

const ObjectEdit = (props) => {
    const model = props.model || (props.match && props.match.params && props.match.params.model)
    const form_definition = model_array.find((model_object) => model_object.name === model).form_definition
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const [status, setStatus] = useState((id && 'fetching') || 'ready')
    const form_data_default = (id && { id }) || {}
    const [form_data, setFormData] = useState(form_data_default)
    const [mounted, setMounted] = useState(false)
    const [needs_to_be_saved, setNeedsToBeSaved] = useState(true)

    if (!mounted && id) {
        setMounted(true)
        get(model + '/' + id)
            // .then(r => r.json())
            .then((r) => console.log(r) || r)
            .then((r) => {
                setFormData(
                    Object.assign(
                        form_data,
                        form_definition.reduce((acc, property) => {
                            acc[property.name] = r[property.name]
                            return acc
                        }, form_data_default)
                    )
                )
                setStatus('ready')
            })
    }

    const setFormDataState = (e) => {
        // console.log('setFormDataState', e.target, { ...form_data, [e.target.name]: e.target.value })
        setFormData({ ...form_data, [e.target.name]: e.target.value })
        setNeedsToBeSaved(true)
        setStatus('ready')
    }
    const setComputedFormDataState = (e) => {
        setFormData({ ...form_data, [e.target.name]: e.target.value })
        console.log('setFormDataState', e.target)
    }

    const save = (e) => {
        e.preventDefault()
        setStatus('loading')
        // console.log(form_data)
        const url = (id && model + '/' + id) || model
        const request = (id && put) || post
        request(
            url,
            Object.keys(form_data).reduce((acc, key) => {
                if (typeof form_data[key] === 'object') {
                    acc[key] = JSON.stringify(form_data[key])
                } else {
                    acc[key] = form_data[key]
                }
                return acc
            }, {})
        ).then((r) => {
            setStatus('saved')
            setNeedsToBeSaved(false)
        })
        return false
    }

    return (
        <React.Fragment>
            {status !== 'fetching' && (
                <form onSubmit={save}>
                    {/* { saved && <Redirect to={`/${model}/list`} /> } */}
                    {form_definition.map((property) => (
                        <FormGroup key={`form-group-${property.name}`}>
                            <Label for={`object-edit-${property.name}`}>{property.label}</Label>
                            {(property.type != 'image' && (
                                <Input
                                    type={property.type || 'text'}
                                    {...property}
                                    name={`${property.name}`}
                                    id={`object-edit-${property.name}-${id}`}
                                    value={form_data[property.name]}
                                    onChange={setFormDataState}
                                />
                            )) || (
                                <Input
                                    type={property.type || 'text'}
                                    {...property}
                                    name={`${property.name}`}
                                    id={`object-edit-${property.name}-${id}`}
                                    value={form_data[property.name]}
                                    onChange={setFormDataState}
                                    parent_model={model}
                                    parent_id={id}
                                    content={form_data[property.name]}
                                    image_key={property.key || undefined}
                                    site_id={(model === 'site' && id) || form_data['site_id']}
                                />
                            )}
                        </FormGroup>
                    ))}

                    <Button color={(needs_to_be_saved && 'primary') || 'success'} disabled={status === 'loading'}>
                        <If condition={status === 'ready'}> Save</If>
                        <If condition={status === 'loading'}>
                            <span>
                                Saving <i className="fal fa-circle-notch fa-spin" />
                            </span>
                        </If>
                        <If condition={status === 'saved'}>
                            <span>
                                Saved <i className="fal fa-check" />
                            </span>
                        </If>
                    </Button>
                </form>
            )}
        </React.Fragment>
    )
}

export default ObjectEdit
